export default "__VITE_ASSET__Dg6v8oeW__"